import { createTheme } from '@mui/material/styles';

export function createAppTheme(mode) {
  const isDark = mode === 'dark';
  return createTheme({
    palette: {
      mode,
      // Light mode: #5b21b6 / #15803d clear WCAG AA 4.5:1 as text on white and as
      // chip/button backgrounds with white text.
      // Dark mode: the same dark accents fail as text on dark backgrounds, so use
      // lighter shades with a dark contrastText. MUI then keeps text, links, and
      // filled buttons (light accent + dark text) all above 4.5:1.
      primary: isDark
        ? { main: '#a78bfa', contrastText: '#0f172a' }
        : { main: '#5b21b6' },
      secondary: isDark
        ? { main: '#4ade80', contrastText: '#0f172a' }
        : { main: '#15803d' },
      background: {
        default: isDark ? '#0f172a' : '#fafaf7',
        paper: isDark ? '#1e293b' : '#ffffff',
      },
      text: {
        primary: isDark ? 'rgba(248, 250, 252, 0.92)' : 'rgba(15, 23, 42, 0.92)',
        secondary: isDark ? 'rgba(248, 250, 252, 0.62)' : 'rgba(15, 23, 42, 0.62)',
      },
      divider: isDark ? 'rgba(248, 250, 252, 0.1)' : 'rgba(15, 23, 42, 0.1)',
    },
    typography: {
      fontFamily: '"Nunito", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
      h1: { fontWeight: 800, letterSpacing: '-0.025em', lineHeight: 1.08 },
      h2: { fontWeight: 700, letterSpacing: '-0.015em' },
      h5: { fontWeight: 700 },
      overline: { letterSpacing: '0.14em', fontWeight: 700 },
    },
    shape: { borderRadius: 14 },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            border: `1px solid ${isDark ? 'rgba(248, 250, 252, 0.08)' : 'rgba(15, 23, 42, 0.08)'}`,
            boxShadow: isDark
              ? '0 1px 3px rgba(0, 0, 0, 0.4)'
              : '0 1px 3px rgba(15, 23, 42, 0.04)',
          },
        },
      },
    },
  });
}
